import { CreativeLibraryPaginationFooter } from '../index/CreativeLibraryPaginationFooter';
import { useAssetsQueryContext } from '../../contexts/AssetsQueryContext';
import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { useTranslations } from '../../hooks/useTranslations';
import { useSelectionContext } from 'modules/creativeLibrary/contexts/SelectionContext';
import { usePanelContext } from 'modules/creativeLibrary/contexts/Panel';
import { Asset, PanelIntent, PanelView } from 'modules/creativeLibrary/types';
import { useCloseModalOverlayContext } from 'modules/creativeLibrary/contexts/CloseModalOverlayContext';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  border-top: ${spacing.single} solid ${colors.grey15};
  padding: 0;
 
  & > div:first-child {
    width: 100%;
    padding: ${spacing.base} ${spacing.double};
    border-top: none;
    overflow-y: hidden;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: ${spacing.half};
  justify-content: flex-end;
  padding: ${spacing.plusQuarter} ${spacing.plusHalf} ${spacing.plusHalf};
  border-top: ${spacing.single} solid ${colors.grey15};
`;

const testIds = {
  cancel: 'pagination-footer-cancel',
  next: 'pagination-footer-next',
};

export const PaginationFooter = () => {
  const { t } = useTranslations();
  const { assetCountTotal } = useAssetsQueryContext();
  const { bulk } = useSelectionContext();
  const { panelIntent, setPanelView, setSelectedAsset } = usePanelContext();
  const { onCloseModal } = useCloseModalOverlayContext();

  return (
    <Container>
      <CreativeLibraryPaginationFooter assetsCount={assetCountTotal} />
      <ButtonContainer>
        <Button
          data-test={testIds.cancel}
          onClick={() => onCloseModal(true)}
          size={BUTTON_SIZES.MEDIUM}
          variant={BUTTON_VARIANTS.SECONDARY}
        >
          <span>{t('button.cancel')}</span>
        </Button>
        <Button
          data-test={testIds.next}
          onClick={() => {
            if (bulk.length === 0) return;
            setSelectedAsset(bulk[0].node as Asset);
            setPanelView(PanelView.Detail);
          }}
          size={BUTTON_SIZES.MEDIUM}
          variant={BUTTON_VARIANTS.PRIMARY}
          isDisabled={bulk.length === 0}
        >
          <span>
            {panelIntent === PanelIntent.Edit || panelIntent === PanelIntent.EditSelect
              ? t('button.change')
              : t('button.next')}
          </span>
        </Button>
      </ButtonContainer>
    </Container>
  );
};
